import React, { Component } from 'react';
import Modal from '../components/modal';
import { Row, Col, Button } from 'react-bootstrap';
import Axios from 'axios';

class AdminAddPrinter extends Component {
    state = {
        printer_id: null,
        brand: null,
        model: null,
        print_bed_x: null,
        print_bed_y: null,
        print_bed_z: null,
        valid: false,
        ip: null,
        api_key: null
    }
    updateValue = (type, value) => {
        let valid = true
        this.setState({ [type]: value }, () => {
            if (this.state.printer_id == null || this.state.printer_id.length < 1) {
                valid = false
            }
            if (this.state.brand == null || this.state.brand.length < 1) {
                valid = false
            }
            if (this.state.model == null || this.state.model.length < 1) {
                valid = false
            }
            if (this.state.ip == null || this.state.ip.length < 1) {
                valid = false
            }
            if (this.state.api_key == null || this.state.api_key.length < 1) {
                valid = false
            }
            if (this.state.print_bed_x == null || isNaN(this.state.print_bed_x) || this.state.print_bed_x < 0.1) {
                valid = false
            }
            if (this.state.print_bed_y == null || isNaN(this.state.print_bed_y) || this.state.print_bed_y < 0.1) {
                valid = false
            }
            if (this.state.print_bed_z == null || isNaN(this.state.print_bed_z) || this.state.print_bed_z < 0.1) {
                valid = false
            }
            this.setState({ valid: valid })
        })
    }
    addPrinter = () => {
        if (this.state.valid) {
            Axios.post("/api/printers/add", { ip: this.state.ip, api_key: this.state.api_key, printer_id: this.state.printer_id, brand: this.state.brand, model: this.state.model, print_bed_x: this.state.print_bed_x, print_bed_y: this.state.print_bed_y, print_bed_z: this.state.print_bed_z })
            this.props.close()
        }

    }
    render() {
        let content = <div>
            <Row>
                <Col>Printer Id:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.printer_id} onChange={(e) => { this.updateValue("printer_id", e.target.value) }} placeholder='Printer Id' />
                </Col>
            </Row>
            <Row>
                <Col>Brand:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.brand} onChange={(e) => { this.updateValue("brand", e.target.value) }} placeholder='brand' />
                </Col>
            </Row>
            <Row>
                <Col>Model:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.model} onChange={(e) => { this.updateValue("model", e.target.value) }} placeholder='model' />
                </Col>
            </Row>
            <Row>
                <Col>IP:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.ip} onChange={(e) => { this.updateValue("ip", e.target.value) }} placeholder='ip' />
                </Col>
            </Row>
            <Row>
                <Col>API Key:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.api_key} onChange={(e) => { this.updateValue("api_key", e.target.value) }} placeholder='api_key' />
                </Col>
            </Row>
            <Row>
                <Col>PrintBed X:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.print_bed_x} onChange={(e) => { this.updateValue("print_bed_x", e.target.value) }} placeholder='print_bed_x' />
                </Col>
            </Row>
            <Row>
                <Col>PrintBed Y:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.print_bed_y} onChange={(e) => { this.updateValue("print_bed_y", e.target.value) }} placeholder='print_bed_y' />
                </Col>
            </Row>
            <Row>
                <Col>PrintBed Z:</Col>
                <Col>
                    <input style={{ width: '100%' }} type='text' value={this.state.print_bed_z} onChange={(e) => { this.updateValue("print_bed_z", e.target.value) }} placeholder='print_bed_z' />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button disabled={!this.state.valid} onClick={() => this.addPrinter()}>Add Printer</Button>
                </Col>
            </Row>

        </div>
        return (

            <Modal close={this.props.close} show={this.props.show} title="Add Printer" content={content} />

        );
    }
}

export default AdminAddPrinter;